import { Badge } from "@hub/components/ui/badge";
import { SelectItem } from "@hub/components/ui/select";
import type { ReleaseOption } from "@hub/ui/use-releases";

/**
 * The version picker's items, shared by every page that picks a release.
 * Shown and disabled rather than hidden when there is no image: a real
 * release vanishing from the list looks like it was deleted.
 */
export function ReleaseItems({ releases }: { releases: readonly ReleaseOption[] }) {
  return releases.map((r) => (
    <SelectItem key={r.tag} value={r.tag} disabled={!r.buildable}>
      <span className="flex items-center gap-2">
        {r.tag}
        {r.prerelease ? (
          <Badge variant="outline" className="text-xs">
            beta
          </Badge>
        ) : null}
        {!r.buildable ? (
          <Badge variant="outline" className="text-xs text-muted-foreground">
            no image
          </Badge>
        ) : null}
      </span>
    </SelectItem>
  ));
}
